export default from './PsychicsPage';



// WEBPACK FOOTER //
// ./src/pages/psychics/index.js